import { GOOGLE_SPOT, MINI_APP_CONSTANTS } from '../../constants';
export const initialState = {
    isSpotLoading: false,
    initiatePaymentResponse: null,
    initiatePaymentStatus: null,
    validatePaymentResponse: null,
    validatePaymentStatus: null,
    transactionStatus: null,
    transactionStatusResponse: null,
};
const paymentsGoogleSpotReducer = (state = initialState, action) => {
    switch (action?.type) {
        case GOOGLE_SPOT.INITIATE_PAYMENT_REQUEST:
        case GOOGLE_SPOT.VALIDATE_RESPONSE:
        case GOOGLE_SPOT.CHECK_TRANSACTION_STATUS:
            return {
                ...state,
                isSpotLoading: true,
                initiatePaymentResponse: null,
                initiatePaymentStatus: null,
                validatePaymentResponse: null,
                validatePaymentStatus: null,
                transactionStatus: null,
                transactionStatusResponse: null,
            };
        case GOOGLE_SPOT.INITIATE_PAYMENT_REQUEST_FAILURE:
            return {
                ...state,
                isSpotLoading: false,
                initiatePaymentStatus: MINI_APP_CONSTANTS.FAILURE,
            };
        case GOOGLE_SPOT.INITIATE_PAYMENT_REQUEST_SUCCESS:
            return {
                ...state,
                isSpotLoading: false,
                initiatePaymentResponse: action?.response,
            };
        case GOOGLE_SPOT.VALIDATE_RESPONSE_FAILURE:
            return {
                ...state,
                isSpotLoading: false,
                validatePaymentStatus: MINI_APP_CONSTANTS.PENDING,
            };
        case GOOGLE_SPOT.VALIDATE_RESPONSE_SUCCESS:
            return {
                ...state,
                isSpotLoading: false,
                validatePaymentResponse: action?.response,
            };
        case GOOGLE_SPOT.CHECK_TRANSACTION_STATUS_FAILURE:
            return {
                ...state,
                isSpotLoading: false,
                transactionStatus: MINI_APP_CONSTANTS.FAILURE,
            };
        case GOOGLE_SPOT.CHECK_TRANSACTION_STATUS_SUCCESS:
            return {
                ...state,
                isSpotLoading: false,
                transactionStatusResponse: action?.response,
            };
        case GOOGLE_SPOT.RESET_PAYMENTS:
            return {
                ...initialState,
            };
        default:
            return state;
    }
};
export default paymentsGoogleSpotReducer;
